import { render, staticRenderFns } from "./DetailPage.vue?vue&type=template&id=e77fdb30&"
import script from "./DetailPage.vue?vue&type=script&lang=ts&"
export * from "./DetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e77fdb30')) {
      api.createRecord('e77fdb30', component.options)
    } else {
      api.reload('e77fdb30', component.options)
    }
    module.hot.accept("./DetailPage.vue?vue&type=template&id=e77fdb30&", function () {
      api.rerender('e77fdb30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/work-order/DetailPage.vue"
export default component.exports